// extracted by mini-css-extract-plugin
export default {"cards":"CatCards_cards__esplS","card":"CatCards_card__J6Ul5","catImage":"CatCards_catImage__bz-8E","cardLink":"CatCards_cardLink__prj-P","noCats":"CatCards_noCats__yTEHz"};